import actionTypes from './type';

const initialState = {
  submit: null,
  title: 'Chắc chắn xóa',
  message: 'Vui lòng xác nhận thao tác của bạn!',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.CONFIRM:
      console.log({ action });
      return {
        ...action,
      };
    case actionTypes.CLEAR:
      return {
        submit: null,
      };
    default:
      return state;
  }
}
